export default "__VITE_ASSET__CqxKg$TK__"